export default "__VITE_ASSET__f73PERJz__"